export * from './translate.service';
export * from './translations';
export * from './translate.pipe';
export * from './translate.module.pipe';


// WEBPACK FOOTER //
// ./src/app/translate/index.ts